<template>
	<div class="detail-product d-flex space-between" v-loading="isLoading">
		<div class="detail-product-slider">
			<div class="wrapper-image-slider">
				<swiper :options="swiperOption" ref="swiperTop">
					<swiper-slide
						v-for="(image, index) in productDetail.images"
						:key="index"
						class="wrapper-image">
							<img 
								:src="image.urlImage" 
								:alt="image.name"
								class="image">
					</swiper-slide>	
				</swiper>
			</div>
			<swiper 
				:options="swiperOptionThumbs" 
				ref="swiperThumbs" 
				class="wrapper-thumbs mt-2">
				<swiper-slide
					v-for="(image, index) in productDetail.images"
					:key="index"
					class="image-thumbs">
						<img 
							:src="image.urlImage" 
							:alt="image.name"
							class="thumbs"
							@click="toSlide(index)">
				</swiper-slide>	
			</swiper>
		</div>
		<div class="detail-product-description">
			<div
				class="wrapper-section space-between"
				:style="`border-top: 0.1rem solid ${globalColors.border};`"
			>
				<div>
					<p class="m-0 text-description">{{productDetail.description}}</p>
					<p class="m-0 text-description pb-1">#{{productDetail.code}}</p>
				</div>
				<div>
					<heart-svg :active="productDetail.flagFavorite" @click="addToFavorites"/>
				</div>
			</div>
			
			<div
				class="wrapper-section wrapper-padding space-between justify-center"
				:style="`border-bottom: 0.1rem solid ${globalColors.border};`"
			>
				<div>
					<p
						class="text-price-now m-0 txt-center"
						:style="`color:${globalColors.primary}`"
					> {{getCurrencySymbol}} {{productDetail.priceDiscount | priceFormat}}</p>
					<p class="text-price-before m-0 txt-center">{{getCurrencySymbol}} {{productDetail.price | priceFormat}}</p>
				</div>
				<div class="d-flex flex-column align-center justify-center">
					<el-rate
						class="mt-2"
						:colors="colors" 
						v-model="productDetail.rating"
						disabled>
					</el-rate>
				</div>
			</div>
			<ProductConversion
				:default-unit="productDetail.unit"
				:conversions="productDetail.conversions"
				@unit-selection="unitSelection"
			/>
			<div
				class="wrapper-section wrapper-padding space-between align-center"
				:style="`border-bottom: 0.1rem solid ${globalColors.border};`"
			>
				<div class="wrapper-counter-general">
					<p class="title-counter">Cantidad</p>
					<div class="d-flex wrapper-counter">
						<button 
							class="counter-sign d-flex align-center justify-center border-counter"
							:style="`color:${globalColors.primary}`"
							@click="changeQuantity('less')">-</button>
						<div 
							class="counter-number d-flex align-center justify-center border-counter">{{productDetail.quantity}}</div>
						<button 
							class="counter-sign d-flex align-center justify-center"
							:style="`color:${globalColors.primary}`"
							@click="changeQuantity('more')">+</button>
					</div>
				</div>
			</div>
			<features-button
				:features="features" 
				@select="selectFeature"
				class="wrapper-features"/>
			<div class="wrapper-buttons d-flex">
				<button
					class="btn"
					:style="`background-color:${globalColors.primary}`"
					:class="{'disabled-btn': noStock}"
					@click="buy"
				>Comprar Ahora</button>
				<button
					class="btn"
					:style="`background-color:${globalColors.hover}`"
					:class="{'disabled-btn': noStock}"
					@click="addToCar"
					>Añadir a Carrito</button>
				<button
					class="btn"
					:class="{'disabled-btn': noStock}"
					:style="`background-color:${globalColors.titulo}`"
					:disabled="disabledBtn"
					@click="productsInWarehouses"
				>Verificar Stock</button>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import featuresButton from '@/components/detail/features';
import timeCounter from '@/components/timeCounter';
import ProductConversion from '@/components/product/productConversion';

function productsInWarehouses() {
	if (this.noStock) {
		this.$message({
			message: 'Producto sin stock',
			showClose: true,
			type: 'error',
		});
	} else {
		this.$emit('warehouse-event');
	}
}

function buy() {
	if (!this.noStock) {
		this.addToCar();
		this.$router.push({ name: 'buy-car' });
	} else {
		this.$message({
			message: 'Producto sin stock',
			showClose: true,
			type: 'error',
		});
	}
}

function toSlide(i) {
	this.$refs.swiperTop.swiper.slideTo(i);
}

function select(model, id) {
	this.product[model] = this.product[model].map((item) => {
		const newItem = { ...item };
		newItem.select = item.id === id;
		return newItem;
	});
}

function changeQuantity(sign) {
	this.$emit('change-quantity', sign);
}

function selectFeature(indexOne, indexTwo) {
	this.$emit('select', indexOne, indexTwo);
}

function created() {
	this.colors = process.env.COLORS;
}

function addToCar() {
	if (!this.noStock) {
		this.$store.dispatch('ADD_PRODUCT_TO_BUY_CAR', this.productDetail);
		this.$emit('product-added', this.productDetail);
	} else {
		this.$message({
			message: 'Producto sin stock',
			showClose: true,
			type: 'error',
		});
	}
}

async function addToFavorites() {
	if (this.token) {
		this.isLoading = true;
		const headers = {
			Authorization: `Bearer ${this.token}`,
		};
		const url = `products/favorite/${this.productDetail.id}`;
		const body = {
			isFavorite: !this.productDetail.flagFavorite,
		};
		await this.$httpQtc.post(url, body, { headers });
		this.$emit('favorite-event', this.productDetail.id);
		this.$set(this.productDetail, 'flagFavorite', !this.productDetail.flagFavorite);
		this.isLoading = false;
	} else {
		this.$message({
			message: 'Debe iniciar sesión para agregar a favoritos',
			showClose: true,
			type: 'error',
		});
	}
}

function noStock() {
	const stock = !!this.productDetail.stockWarehouse;
	const positiveStock = this.productDetail.stockWarehouse > 0;
	return !(stock && positiveStock);
}

function unitSelection(unitSelected) {
	this.$emit('selected-unit', unitSelected);
}

function data() {
	return {
		colors: [],
		isLoading: false,
		product: {},
		swiperOption: {
			slidesPerView: 1,
		},
		swiperOptionThumbs: {
			spaceBetween: 10,
			slidesPerView: 5,
		},
	};
}

export default {
	name: 'detail-product',
	components: {
		featuresButton,
		heartSvg: () => import('@/components/svg-components/heartSvg'),
		ProductConversion,
		swiper,
		swiperSlide,
		timeCounter,
	},
	computed: {
		...mapGetters([
			'getCurrencySymbol',
			'token',
		]),
		noStock,
	},
	created,
	data,
	methods: {
		addToCar,
		addToFavorites,
		buy,
		changeQuantity,
		productsInWarehouses,
		select,
		selectFeature,
		toSlide,
		unitSelection,
	},
	props: {
		features: {
			type: Array,
			default: () => [],
		},
		images: {
			type: Array,
			default: () => [],
		},
		productDetail: {
			type: [Object, Array],
			default: () => {},
		},
		disabledBtn: {
			type: Boolean,
			default: false,
		},
	},
};
</script>
<style lang="scss">

.detail-product {
	padding: 4rem 8%;

	.m-0 {
		margin: 0;
	}

	.el-rate__icon {
		font-size: 3.1rem;
	}

	.el-rate {
		height: 4.5rem;
	}
}

.detail-product-slider {
	width: 47.9rem;

	.wrapper-image-slider {
		box-shadow: 0 0.2rem 0.4rem 0 rgba(175, 175, 175, 0.5);
	}

	.wrapper-image {
		height: 47.9rem;
	}

	.image {
		display: block;
		margin: auto;
		max-width: 90%;
		max-width: 90%;
		position: relative;
		top: 50%;
		transform: translateY(-50%);
	}

	.wrapper-thumbs {
		height: 9.9rem;
	}

	.image-thumbs {
		border: 0.1rem solid color(borderThum);
		height: 9.6rem;
		width: 9.7rem !important;

		&.swiper-slide-active {
			border: 0.1rem solid color(activeGrey);
		}
	}

	.thumbs {
		display: block;
		cursor: pointer;
		margin: auto;
		max-height: 95%;
		max-width: 99%;
		position: relative;
		top: 50%;
		transform: translateY(-50%);
	}

	.wrapper-discount {
		background: color(redBold);
		color: white;
		font-family: font(open-semibold);
		font-size: size(normal);
		margin-bottom: 1.7rem;
		padding: 1.8rem 1.6rem;
	}

	.text-red {
		background-color: white;
		border-radius: 0.2rem;
		color: color(redBold);
		font-size: size(medium);
		padding: 0.9rem 0.8rem;
	}
}

.detail-product-description {
	width: 45%;

	.wrapper-section {
		align-items: flex-start;
		display: flex;
	}

	.text-description {
		font-size: size(large);
		line-height: 3rem;
		width: 98%;
	}

	.like-heart {
		height: 3.6rem;
	}

	.text-price-now {
		font-family: font(open-semibold);
		font-size: size(maxlarge);
	}

	.text-price-before {
		color: color(text-grey);
		font-size: size(minlarge);
		position: relative;

		&::before {
			border-color: color(mediumGrey);
			border-top: 0.1rem solid;
			content: "";
			left: 0;
			position: absolute;
			right: 0;
			top: 50%;
		}
	}

	.star-like {
		height: 2.8rem;
		margin: 0 1.6rem 1rem 0;

		&:last-child {
			margin: 0 0 1rem 0;
		}
	}

	.wrapper-counter {
		border: 0.1rem solid color(backGrey);
		height: 6.9rem;
		width: 100%;
		font-family: font(open-semibold);
		font-size: size(minlarge);
	}

	.counter-sign {
		background: none;
		border: none;
		cursor: pointer;
		font-size: size(maxsmall);
		outline: none;
		flex: 1 1 auto;
	}

	.counter-number {
		color: color(textBoldGrey);
		flex: 1 1 auto;
	}

	.border-counter {
		border-right: 0.1rem solid color(backGrey);
	}

	.counter-text {
		background: color(redBold);
		color: white;
		font-family: font(open-semibold);
		font-size: size(small);
		padding: 1rem;
		width: 40%;
	}

	.title-counter {
		color: color(titleGrey);
		font-family: font(open-semibold);
		font-size: size(maxsmall);
		margin: 1.3rem 1rem 1rem 0;
		width: 4.9rem;
	}

	.item-color {
		background: color(whiteBold);
		border: none;
		color: color(titleGrey);
		cursor: pointer;
		font-size: size(normal);
		margin: 0 1.5rem 1.2rem 0;
		outline: none;
		padding: 1.5rem 1.6rem;
		transition: all .4s ease-in-out 0s;
		
		&:hover, &.active {
			background: color(blackBold);
			color: white;
		}
	}

	.wrapper-padding {
		padding: 1.6rem 5%;
	}

	.wrapper-buttons {
		margin-top: 2rem;

		.btn {
			border: none;
			color: white;
			font-size: size(large);
			margin-right: 0.9rem;
			outline: none;
			padding: 1.5rem 0.5rem;

			&:last-child {
				margin-right: 0;
			}
		}
	}
	
	.wrapper-counter-general {
		width: 40%;
	}
}

.wrapper-features {
	margin-top: 2.5rem;
}

	@media screen and (max-width: 1106px){
		.detail-product-description {
			width: 40%;
		}
	}

	@media screen and (max-width: 1024px) {
		.detail-product {
			flex-direction: column;

			.el-rate__icon {
				font-size: size(normal);
			}

			.el-rate {
				height: 3rem;
			}
		}

		.detail-product-slider {
			width: 100%;

			.wrapper-image {
				height: 26.1rem;
			}

			.image {
				max-height: 90%;
			}

			.wrapper-discount {
				font-size: size(tiny);
				margin-top: 1.5rem;
			}

			.text-red {
				font-size: size(small);
				padding: 0.5rem;
			}

			.image-thumbs {
				height: 7rem;
				width: 7rem !important;
			}

			.wrapper-thumbs {
				width: 80%;
			}
		}

		.detail-product-description {
			width: 100%;

			.text-description {
				font-size: size(small);
				line-height: 2rem;
			}

			.like-heart {
				height: 2.8rem;
			}

			.text-price-now {
				font-size: size(minlarge);
			}

			.text-price-before {
				font-size: size(maxsmall);
			}

			.star-like {
				height: 1.6rem;
				margin: 0 0.6rem 1rem 0;
			}

			.title-counter {
				font-size: size(small);
				width: 3.3rem;
			}

			.wrapper-counter {
				font-size: size(normal);
				height: 5rem;
			}

			.counter-text {
				font-size: size(tiny);
			}

			.item-color {
				font-size: size(small);
				padding: 0.7rem;
			}

			.wrapper-buttons {
				flex-direction: column;

				.btn {
					font-size: size(normal);
					margin: 0 0 1.2rem 0;
				}
			}
		}
	}

	.text-discont {
		font-size: size(msmall);
		margin: 0 0 1rem 0;
		text-align: center;
		white-space: nowrap;
	}
</style>





// WEBPACK FOOTER //
// product.vue?6a8de77e